module.exports = __webpack_public_path__ + "static/background-b1d4f78f1154123cdae4c98f6cf63150.png";